import React from "react"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import { colorCode } from "../../functions/middle-category-style"
import { Link } from "gatsby"

// ファーストビュー「ピックアップ記事」のテンプレート

export default function ContentTemplate({
  publishDate,
  title,
  subtitle,
  imageUrl,
  tagName,
  link,
  category,
}) {
    return (
      <Link to={link} className='rc_flex_item'>
        <div className='item_tag'>今読みたいおすすめ記事</div>
        <div className="item_img">
          { imageUrl !== '' ?
            <LazyAndPreloadImage imgUrl={imageUrl} alt={"Top画像"} />
            : ''
          }
        </div>
        <div className='item_descroption'>
          <div className='item_title'>{title}</div>
          <div className='item_subtitle'>{subtitle}</div>
        </div>
      </Link>
  )
}
